import { inject } from "@angular/core";
import { Params, RedirectFunction, Router, UrlTree } from "@angular/router";

/**
 * Las pantallas de quien pide IA o Mantenimiento viven dentro de «Nueva
 * solicitud» desde el 12/10/2026 (pedido de Norman: un solo módulo para
 * pedir y seguir). Sus rutas de antes siguen sirviendo —enlaces guardados,
 * accesos directos, el historial del navegador— y llevan al concentrador
 * en la vista que corresponde, con los parámetros que traigan.
 *
 * Las hojas del menú (admin/solicitudes-ia/solicitud y
 * admin/mantenimiento/solicitud) NO se borran: el servidor las usa como
 * llave del permiso (SolicitudIABuss.MENU_SOLICITUD y
 * MantenimientoBuss.MENU_SOLICITUD). Solo dejan de pintarse en el panel
 * (FUERA_DEL_PANEL en shared/menu/ruta-menu.ts).
 */
export const RUTA_CONCENTRADOR = "/solicitudes/nueva";

function alConcentrador(queryParams: Params, vista: Params): UrlTree {
  return inject(Router).createUrlTree([RUTA_CONCENTRADOR], {
    queryParams: { ...queryParams, ...vista },
  });
}

/** /admin/solicitudes-ia/solicitud → pedir una IA dentro del concentrador. */
export const aSolicitudIa: RedirectFunction = ({ queryParams }) => alConcentrador(queryParams, { tipo: "ia" });

/**
 * /admin/mantenimiento/solicitud → «Mis solicitudes de mantenimiento».
 * Respeta ?solicitud=12 (abre su detalle), que usan «Ver mi solicitud» y
 * los enlaces viejos.
 */
export const aMisMantenimiento: RedirectFunction = ({ queryParams }) =>
  alConcentrador(queryParams, { ver: "mantenimiento" });
